import React from "react";
import {ActionRow, ActionRowButton, ActionRowMoreButton, Icon} from "peggirkit";
import {PlusIcon} from "@heroicons/react/24/outline";
import {FormattedMessage} from "react-intl";
import {ListBulletIcon} from "@heroicons/react/20/solid";
import router from "@/routing/Router";

type Props = {
    isFetching: boolean,
};

const MenuOverviewHeadingActions = ({isFetching}: Props) => {
    return (
        <ActionRow
            useMoreButton={true}
            moreButton={
                <ActionRowMoreButton>
                    <FormattedMessage id={"more"}/>
                </ActionRowMoreButton>
            }
            moreButtonPositioning={"end"}
            breakpoints={{
                md: {
                    moreButtonPositioning: "start",
                },
            }}
        >
            <ActionRowButton
                color={"secondary"}
                iconBefore={<Icon icon={ListBulletIcon}/>}
                disabled={isFetching}
                buttonAction={{
                    as: "reactRouterLink",
                    actionProps: {
                        to: router.optionGroups.absolutePath(),
                    }
                }}
            >
                <FormattedMessage id={"optionGroups"}/>
            </ActionRowButton>
            <ActionRowButton
                color={"primary"}
                iconBefore={<Icon icon={PlusIcon}/>}
                disabled={isFetching}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: () => {
                            alert("Work in progress");
                        }
                    }
                }}
            >
                <FormattedMessage id={"newCategory"}/>
            </ActionRowButton>
        </ActionRow>
    );
};

export default MenuOverviewHeadingActions;